import React from 'react';
import InfoTip from '../InfoTip';
import { MonthStats } from './model';
import * as fmt from '../../lib/format';

interface Props {
  stats: MonthStats;
  /** How many people the month has before the group and search narrow them. */
  allPeople: number;
  /** Pressing "weekdays with no log" shows only those days in the grid. */
  noLogOn: boolean;
  onNoLog: () => void;
}

const TILE = 'rounded-xl bg-gray-50 px-4 py-3 ring-1 ring-gray-200/60';
const LABEL = 'text-xs font-medium text-gray-500';
const VALUE = 'mt-0.5 text-2xl font-semibold tabular-nums tracking-tight text-gray-900';
const SUB = 'text-xs text-gray-500';

// The month at a glance for the people on screen: it follows the group and the search.
export default function SummaryStrip({ stats, allPeople, noLogOn, onNoLog }: Props) {
  return (
    <div className="mb-4 grid grid-cols-2 gap-3 lg:grid-cols-4" aria-label="The month at a glance">
      <div className={TILE}>
        <div className={LABEL}>Hours logged</div>
        <div className={VALUE}>{fmt.hours(stats.hours)}</div>
        <div className={SUB}>this month so far</div>
      </div>
      <div className={TILE}>
        <div className={LABEL}>People</div>
        <div className={VALUE}>{stats.people}</div>
        <div className={SUB}>{stats.people === allPeople ? 'with time logged' : `of ${allPeople} with time logged`}</div>
      </div>
      <div className={TILE}>
        <div className={LABEL}>Average a day</div>
        <div className={VALUE}>{fmt.hours(stats.averagePerLoggedDay)}</div>
        <div className={SUB}>per person, on days they logged</div>
      </div>
      <div className={`${TILE} ${noLogOn ? 'ring-2 ring-blue-500' : ''}`}>
        <div className="flex items-center">
          <span className={LABEL}>Weekdays with no log</span>
          <InfoTip id="worklogs.no-log" />
        </div>
        <button
          type="button"
          onClick={onNoLog}
          aria-pressed={noLogOn}
          className="mt-0.5 block w-full rounded-md text-left transition-colors hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 motion-reduce:transition-none"
        >
          <span className={VALUE.replace('mt-0.5 ', '')}>{stats.missing}</span>
          <span className={`block ${SUB}`}>
            {stats.under} {stats.under === 1 ? 'day' : 'days'} under 5 h · {noLogOn ? 'showing them' : 'press to show'}
          </span>
        </button>
      </div>
    </div>
  );
}
